// Formatters
// Formatting utilities for display

/**
 * Format customer full name
 *
 * @param {string} firstName - First name
 * @param {string} lastName - Last name
 * @returns {string} Full name
 */
export function formatFullName(firstName, lastName) {
    return `${firstName} ${lastName}`;
}

/**
 * Extract name from email (fallback when name is not available)
 *
 * @param {string} email - Email address
 * @returns {string} Name extracted from email
 */
export function getNameFromEmail(email) {
    if (!email) return '';
    return email.split('@')[0];
}

/**
 * Format attention type for display
 *
 * @param {string} attentionType - Attention type
 * @returns {string} Formatted attention type
 */
export function formatAttentionType(attentionType) {
    return attentionType || 'No especificado';
}

/**
 * Format duration in seconds to readable format
 *
 * @param {number} seconds - Duration in seconds
 * @returns {string} Formatted duration (e.g., "5m 30s")
 */
export function formatDuration(seconds) {
    if (!seconds || seconds < 0) return '0s';

    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;

    if (minutes > 0) {
        return `${minutes}m ${remainingSeconds}s`;
    }
    return `${seconds}s`;
}

/**
 * Get status display text
 *
 * @param {string} status - Status code
 * @returns {string} Human-readable status
 */
export function getStatusDisplayText(status) {
    const statusMap = {
        'waiting': 'Esperando',
        'calling': 'Llamando',
        'serving': 'Atendiendo',
        'standby': 'En Pausa',
        'done': 'Finalizado',
        'no-show': 'No se presentó'
    };

    return statusMap[status] || status;
}
